// extracted by mini-css-extract-plugin
export default {"checkbox-form-control-container":"styles_checkbox-form-control-container__LPB-c"};